import React from 'react';

/**
 * Inline error message component with consistent styling
 * Used for displaying error states in forms, panels, etc.
 */
const ErrorMessage = ({ message, className = '' }) => {
    if (!message) return null;

    return (
        <div className={`bg-red-50 border border-red-200 rounded-lg p-4 ${className}`}>
            <div className="text-sm text-red-800">{message}</div>
        </div>
    );
};

export default ErrorMessage;
